// @core/api/endpoints/chat/create_mention_tag.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateMentionTagRequest,
  MentionTagResponse,
} from '../../../types/chat';

const BASE_PATH = '/chat';

/**
 * Create a mention tag
 * Creates a custom mention tag for the conversation. Users can subscribe to tags and receive notifications when the tag is mentioned in a message.
 */
export async function CreateMentionTag(
  conversation_id: string,
  data: CreateMentionTagRequest,
  options?: RequestOptions
): Promise<MentionTagResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversations/:conversation_id/mention-tags`;
  requestPath = requestPath.replace(':conversation_id', encodeURIComponent(conversation_id));
  const requestOptions = options;
  return client.post<MentionTagResponse>(requestPath, data, requestOptions);
}
